import React from "react";
import styled from "styled-components";
import PizzaLogo from "../assets/dishes-img/pizza-logo.png";
import { ReactComponent as PizzaLeaking } from "../assets/components-icons/pizza-leaking.svg";
import { ReactComponent as Scooter } from "../assets/components-icons/scooter.svg";
import { ReactComponent as Menu } from "../assets/components-icons/menu.svg";
import { ReactComponent as Twitter } from "../assets/social-icons/svg/013-twitter-1.svg";
import { ReactComponent as Instagram } from "../assets/social-icons/svg/034-instagram.svg";
import { ReactComponent as Facebook } from "../assets/social-icons/svg/043-facebook-1.svg";
import { useHistory, Link } from "react-router-dom";
import { UserContext } from "../context/user";
import { CartServerSide } from "../context/api_response";
import { navlist } from "../helpers/navlist";

const Side_bar = () => {
  const [sideOpen, setSideOpen] = React.useState(false);
  const { total, cart, orders, userInfo } = React.useContext(CartServerSide);
  const { user, userLogout } = React.useContext(UserContext);
  let history = useHistory();

  const handleOpen = () => {
    setSideOpen(!sideOpen);
  };

  return (
    <>
      <div className="sidebar-nav">
        <ul>
          <div>
            <li>
              <Menu onClick={handleOpen} className="sidebar-icon" />
            </li>
          </div>
          <div>
            <li>
              <PizzaLeaking className="sidebar-icon" />
            </li>
          </div>
        </ul>
      </div>

      <SidebarWrapper visible={sideOpen}>
        <div className="d-flex  p-3 flex-column">

          <div className="img-container d-flex justify-content-center">
            <img src={PizzaLogo} height="100px" alt="pizza-logo" />
          </div>

          {user.token && (
            <Link onClick={handleOpen} to="/cart-page">
              <div className="d-flex border-around position-relative justify-content-around  mt-3 mb-3">
                <Scooter className="svgAll scooter-icon" />
                { cart.length === 0 ? 
                <small> Your cart  is empty </small>
                :
                <>
                <small>Your cart total is:</small>
                <h6> ${total} </h6>
                <div className="amount position-absolute">
                  {cart.length}
                </div>
                </>
              }
                
              </div>
            </Link>
          )}

          <div className="mt-3 d-flex flex-column  mb-3">
            { navlist.map((item) => {
              return <span className='mt-1' to={item.link} onClick={() => {
                handleOpen()
                history.push(`${item.link}`)
              }} key={item.id}> { user.token ? item.text : item.textLogin } { orders.length > 1 && item.textOrder } </span>
            }) }
            { user.token && <span className='mt-1' onClick={()=>{
              handleOpen()
              userLogout()
            }}  > Logout </span> }
            { user.token && <span className='mt-1'>{userInfo.username}</span> }


            <div className="mt-2">
              <Menu onClick={handleOpen} className="svgAll  social-icons" />
            </div>
          </div>


          <div className='bottom-icons'>
              <div className="social-icons-div">
              <a href="https://www.facebook.com/">
                <Facebook className="social-icons svgAll" />
              </a>
            </div>

            <div className="social-icons-div">
              <a href="https://www.facebook.com/">
                <Twitter className="social-icons svgAll" />
              </a>
            </div>

            <div className="social-icons-div">
              <a href="https://www.facebook.com/">
                <Instagram className="social-icons svgAll" />
              </a>
            </div>
          </div>



          <div className='bottom-text'>
            <p>
              copyright &copy; Pizza Store {new Date().getFullYear()} all rights
              reserved.
            </p>
          </div>
        </div>
      </SidebarWrapper>
    </>
  );
};

const SidebarWrapper = styled.div`
  .scooter-icon {
    fill: var(--checkout-product-descr);
  }

  .bottom-icons {
    position: absolute;
    bottom: 10%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    max-width: 200px;
  }

  .bottom-icons > a {
    margin-left: 15px;
  }

  .bottom-text {
    position: fixed;
    bottom: 3%;
  }

@media screen and (max-width: 375px) {
  .bottom-text {
    bottom: 1%;
  }
}

  p {
    color: #838383;
    font-size: 12px;
    font-family: var(--primaryFont);
  }

  .social-icons {
    fill: var(--socialIcons);
  }

  .social-icons-div {
    padding: 5px;
    border-radius: 50%;
    width: 35px;
    text-align: center;
    border: 1px solid var(--checkout-product-descr);
  }

  h6 {
    font-size: 14px;
    color: var(--productTitle);
    font-weight: bold;
  }

  small {
    font-size: 12px;
    color: var(--checkout-product-descr);
    font-weight: lighter;
  }

  .amount {
    background: var(--successAlert);
    color: white;
    font-weight: bold;
    font-size: 11px;
    border-radius: 50%;
    width: 8%;
    height: 49%;
    text-align: center;
    padding: 4px;
    top: 0px;
    left: 5px;
  }

  span {
    font-size: 15px;
    font-weight: bold;
    color: var(--sidebarLinks);
    text-decoration: none;
  }

  transform: ${(props) =>
    props.visible ? "translateX(0)" : "translateX(-130%)"};
  position: fixed;
  z-index: 6;
  transition: all 0.5s linear;
  box-shadow: 8px 4px 5px -4px rgba(0, 0, 0, 0.29);
  top: 0px;
  left: 0px;
  right: 0px;
  width: 70%;
  height: 100%;
  background: #ffffff;
  @media screen and (max-width: 280px) {
    width: 100%;
  }
`;

export { Side_bar as default };
